/**
 * @file index.ts
 * @description i18n exports for PaymentErrorBoundary (Task 33.1)
 */

import { paymentErrorTranslations as enTranslations, PaymentErrorTranslations } from './en';

export type SupportedLocale = 'en';

const translations: Record<SupportedLocale, PaymentErrorTranslations> = {
  en: enTranslations,
};

/**
 * Get payment error translations for a given locale
 * @param locale - The locale to get translations for (default: 'en')
 * @returns PaymentErrorTranslations object for the specified locale
 */
export const getErrorTranslations = (locale: SupportedLocale = 'en'): PaymentErrorTranslations => {
  return translations[locale] || translations.en;
};

export type { PaymentErrorTranslations };
